import React from 'react';

import { capitalize, isEmpty } from 'lodash';

import { useScreenMediaQuery } from '@shared/hooks';

import { Button } from '@/widgets';
import { CrossIcon } from '@/assets/icons';
import { TEST_IDS } from '@/constants/testConstants';

import styles from './FilterChips.module.scss';

const FILTER_DISPLAY_NAME_MAPPING = {
	terminalIds: 'Terminals',
	storeIds: 'Stores',
	qrCodes: 'QR Codes',
	status: 'Status',
	instruments: 'Mode Of Payment',
	paylinkStatus: 'Paylink Status',
};
const { CLEAR_ALL_FILTER_CHIPS, FILTER_CHIPS_WRAPPER, FILTER_CHIPS_GROUP } =
	TEST_IDS;

const FilterChips = ({
	filters,
	removeFilter,
	resetFilters,
	openFilterModal,
}) => {
	const isMobile = useScreenMediaQuery('maxMobile');
	const FILTER_COUNT_TO_SHOW = isMobile ? 1 : 3;

	if (isEmpty(filters)) return null;

	const getFilterName = (filterName) =>
		FILTER_DISPLAY_NAME_MAPPING[filterName] || filterName;

	const renderAppliedFilter = (filterType, filterName) => (
		<div
			className={styles.filterValueItem}
			key={filterName.title}
			aria-label={filterName.title}
		>
			<span className={styles.filterValueText}>
				{capitalize(filterName.title)}
			</span>
			<CrossIcon onClick={() => removeFilter(filterType, filterName)} />
		</div>
	);
	const renderMultipleAppliedFilters = (filterType) => {
		const multipleFiltersArr = [...filters[filterType]];
		const moreFilterCount = multipleFiltersArr.length - FILTER_COUNT_TO_SHOW;
		if (multipleFiltersArr.length > FILTER_COUNT_TO_SHOW) {
			multipleFiltersArr.length = FILTER_COUNT_TO_SHOW;
		}
		return (
			<>
				{multipleFiltersArr.map((filterItem) =>
					renderAppliedFilter(filterType, filterItem),
				)}
				{moreFilterCount > 0 && (
					<div
						className={styles.moreText}
						onClick={() => openFilterModal(filterType)}
					>
						+ {moreFilterCount} more
					</div>
				)}
			</>
		);
	};

	return (
		<div className={styles.filtersContainer} data-id={FILTER_CHIPS_WRAPPER}>
			{Object.keys(filters).map((filterType) => {
				if (!isEmpty(filters[filterType])) {
					return (
						<div className={styles.filterGroupWrapper} key={filterType}>
							<div className={styles.filterTypeText}>
								{getFilterName(filterType)}
							</div>
							<div
								className={styles.filterValueWrapper}
								data-id={FILTER_CHIPS_GROUP}
							>
								{renderMultipleAppliedFilters(filterType)}
							</div>
						</div>
					);
				}
			})}
			<Button
				onClick={resetFilters}
				className={styles.clearAllButton}
				data-id={CLEAR_ALL_FILTER_CHIPS}
			>
				Clear All
			</Button>
		</div>
	);
};

export default FilterChips;
